import React, { useEffect, useState } from 'react'
import Modal from '../../components/common/modal/Modal'
import SinglePage from '../../components/common/page/SinglePage'
import SpinWithMessage from '../../components/common/spinners/SpinWithMessage'
import { BsDatabaseFillX } from 'react-icons/bs'
import { accountingAxios } from '../../config/axios'
import toast from 'react-hot-toast'
import TableFilter from '../../components/common/table-filter/TableFilter'
import { TbArrowNarrowRight } from "react-icons/tb";
import { useNavigate, useSearchParams } from 'react-router-dom'
import FilterAllocation from '../../components/user/finance/FilterAllocation'


const Allocations = () => {
    const [modal, setModal] = useState({ status: false })
    const [data, setData] = useState([])
    const [loading, setLoading] = useState('fetch')
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()

    useEffect(() => {
        accountingAxios.get('/v2/allocations', {
            params: {
                receipt_no: searchParams.get('receipt_no'),
                transaction_id: searchParams.get('transaction_id'),
                bill_no: searchParams.get('bill_no'),
                from_date: searchParams.get('from_date'),
                end_date: searchParams.get('end_date')
            }
        }).then((response) => {
            setData(response.data)
            setLoading('')
        }).catch((error) => {
            toast.error(error.message)
            setLoading('')
        })
        // eslint-disable-next-line
    }, [searchParams.get('from_date'), searchParams.get('end_date'), searchParams.get('bill_no'), searchParams.get('receipt_no'),
    // eslint-disable-next-line
    searchParams.get('transaction_id')
    ])

    const filterModal = () => {
        setModal({
            status: true,
            title: "Filter",
            content: <FilterAllocation setModal={setModal} />
        })
    }

    return (
        <div className="allocations-list">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['Allocations List']}>
                {data[0] ? <TableFilter
                    srlNo={true}
                    topRight={<button onClick={filterModal}>Filter</button>}
                >
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Bill No</th>
                                <th>Receipt No</th>
                                <th>Transaction Id</th>
                                <th>Amount</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index} >
                                    <td>{new Date(item?.allocated_at).toDateString()}</td>
                                    <td onClick={() => navigate(`/bills?bill_no=${item?.bill_no}`)} style={{ cursor: 'pointer' }}>{item?.bill_no} <TbArrowNarrowRight color='blue' /></td>
                                    <td onClick={() => navigate(`/receipts?receipt_no=${item?.receipt_no}`)} style={{ cursor: 'pointer' }}>{item?.receipt_no} <TbArrowNarrowRight color='blue' /></td>
                                    <td onClick={() => navigate(`/transactions?transaction_id=${item?.transaction_id}`)} style={{ cursor: 'pointer' }}>{item?.transaction_id} <TbArrowNarrowRight color='blue' /></td>
                                    <td>₹ {item?.allocated_amount}</td>
                                    <td>{item?.status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </TableFilter>
                    : <SpinWithMessage icon={!loading && <BsDatabaseFillX />} message={loading ? 'Fetch data...' : 'No data'} spin={loading}
                        bottomContent={<>
                            <button onClick={filterModal}>Filter</button>
                        </>} />
                }
            </SinglePage>
        </div>
    )
}

export default Allocations